import type { CalendlyProps } from "components/CalendlyButton"
import CalendlyButton from "components/CalendlyButton"
import { ReactComponent as ArrowSVG } from "images/arrowUpRight.svg"
import { ReactComponent as PlayButtonSVG } from "images/play.svg"
import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

type SecondaryCTAProps = CalendlyProps & {
	/**
	 * @default "withArrow"
	 */
	variant?: "withArrow" | "withPlayButton"
}

export default function SecondaryCTA({
	children,
	variant = "withArrow",
	...props
}: SecondaryCTAProps) {
	return (
		<Link {...props}>
			<Clipper $noTranslate={variant === "withPlayButton"}>
				{variant === "withArrow" && <Arrow />}
				{variant === "withPlayButton" && <PlayButton />}
				<div>{children}</div>
			</Clipper>
		</Link>
	)
}

const Clipper = styled.div<{ $noTranslate?: boolean }>`
	${({ $noTranslate }) =>
		fresponsive(css`
			overflow: clip;
			display: flex;
			align-items: center;
			margin: -10px 0;
			padding: 10px 0;

			@media (hover: hover) {
				& > svg {
					translate: ${$noTranslate ? "0 0" : "-18px 0"};
					transition: translate 0.2s ${eases.quad.inOut};
				}

				& > div {
					translate: ${$noTranslate ? "0 0" : "-9px 0"};
					transition: translate 0.2s ${eases.quad.inOut};
				}
			}
		`)}
`

const Link = styled(CalendlyButton)`
	${textStyles.button1medium}
	${fresponsive(css`
		border-radius: 16px;
		border: 1px solid ${colors.blue3};
		background: ${colors.transBlue1};
		color: ${colors.blue3};
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 18px 24px;
		gap: 10px;
		transition: 0.2s ${eases.quad.inOut};
		transition-property: background, color;

		&:hover {
			background: ${colors.blue2};
			color: white;

			${Clipper} > * {
				translate: 0 0;
			}
		}
	`)}
`

const Arrow = styled(ArrowSVG)`
	path {
		stroke: white;
	}

	${fresponsive(css`
		width: 12px;
		height: 12px;
		margin-right: 6px;

		@media (hover: none) {
			display: none;
		}
	`)}
`

const PlayButton = styled(PlayButtonSVG)`
	path {
		stroke: currentcolor;
	}

	${fresponsive(css`
		width: 12px;
		height: 12px;
		margin-right: 6px;
	`)}
`
